import { render } from "./Proveedor_Shopify.vue?vue&type=template&id=61630b7e"
import script from "./Proveedor_Shopify.vue?vue&type=script&lang=js"
export * from "./Proveedor_Shopify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__